/* Add categories    */
/* Add Preference  Mar 13, 2022  */
/* Add roles  Oct 30, 2022 */
/* Add pDebriefQuestion to Debrief as a title July 17, 2023 */
/* Add customFields Aug 5, 2023 */
/* Add Construction Scope, Vendor Status Dec 30, 2023 */
/* Amend CSS btn-back border:none Apr 13, 2024 */
<template lang="pug">
	b-row(id="settings")
		b-col
			//- p(class="btn btn-sm btn-link"  @click="m_goToMain()") Return to App
			b-button(class="btn-back" title="Back" variant="outline-primary" @click="m_goBack")
				fa-icon(icon="arrow-left")
			b-nav(tabs vertical class="text-left")
				div(v-for="sg in d_settings" :key="sg.grpKey")
					b-nav-text {{sg.grpLbl}}
					b-nav-item(v-for ="s in sg.settings" :key="s.key" :active="s.key == d_currSetting.key"  
						@click="m_onClickSetting(s, sg)") {{m_labelHelper(s)}}
		b-col(class="border")
			div(class="bg-light px-2 py-1 mb-1") 
				span() Settings
				span(v-if="d_currSetting.key" class="font-weight-bolder small pl-1" ) | {{m_labelHelper(d_currSetting)}}
			div(class="p-2" v-if="!d_currSetting.key")
				p The setting section allows users with elevated access to configure certain application settings and user permissions. 
				p Use the links found on the left side of the screen to navigate and make necessary changes.
				p If you have any questions or concerns, please send an email to info@kiesetechnologies.com.
			div(class="small px-2 pb-2 text-danger" v-show="!/^(teamAnnc|)$/.test(d_currSetting.key||'')")
				div Note: Currently logged in users must refresh the browser window for changes to be reflected.
			//- Loading
			kt-spinner(v-if="d_loading" p_txt="Settings")
			div(v-if="d_currSetting.key && d_currSetting.type=='tbl' && !d_errMessage" class="px-1" v-show="!d_loading")
				kt-settings-tbl(:p_settingProps="d_currSetting" :p_settingData="d_settingData" :p_refData="d_refData")
			
			div(v-else-if="d_currSetting.key && d_currSetting.type=='frm' && !d_errMessage" class="px-1" v-show="!d_loading")
				kt-settings-frm(:p_settingProps="d_currSetting" :p_settingData="d_settingData" :p_refData="d_refData")

			div(v-if="d_errMessage" class="text-center mt-4")
				p(class="text-danger") Something1 went wrong ☹
				p(class="my-1 small text-grey5") {{d_errMessage}}
				p(class="small") You may try again or refresh your browser session.
			
</template>

<script>

import {settings as api} from "@/utils/api.js";
import KTSettingsTbl from "@/components/Ctrl/KT-SettingsTbl.vue";
import KTSettingsFrm from "@/components/Ctrl/KT-SettingsFrm.vue";
import {kbdpAlert, fn_humanizeLabel} from "@/utils/util.js";


export default {
	name: "settings",
	components: {
		'kt-settings-tbl': KTSettingsTbl,
		'kt-settings-frm': KTSettingsFrm,

	},
	created() {console.log('In settings created')},
	mounted() {console.log('In settings mounted')},
	data() {
		return {
			d_settings: fn_getSettings(),
			d_currSetting: {},
			d_settingData: null,
			d_refData: null,
			d_errMessage: null,
			d_loading: null,
			d_formEdited: false,
		};
	},
	props: {},
	computed: {},
	methods: {
		m_labelHelper(cs) {
			if (!cs) return;
			if (cs.label) return cs.label;
			let lbl = fn_humanizeLabel(cs.key);
			if (!cs.plr) return lbl;
			if (cs.plr == 's' ) return lbl + 's';
			if (cs.plr == 'es') return lbl + cs.plr;
			if (cs.plr == 'ies') return lbl.slice(0, -1) + cs.plr;
		},
		m_goToMain() {
			if (this.$route.hash != '') {
				this.$router.push({name: 'KBDP'});
				//this.$router.go(-1);
			}
		},
		m_goBack() {
			if (this.$route.hash != '') this.$router.go(-1);	
		},
		m_onClickSetting(s, sg) {
			let _this = this;
			if (s.key == _this.d_currSetting.key) return; //ignore if clicked twice

			kbdpAlert.clear();
			_this.d_currSetting = s;
			s.grpKey = sg.grpKey;
			if (!s.cols) s.cols = sg.cols;

			if (sg.type) s.type = sg.type; //ddo
			if (!s.context) s.context = s.key;//ddo

			_this.d_loading = true;
				console.log('s.context');
				console.log(s.context);
				console.log('s.category');
				console.log(s.category);
			api.fn_getData(s.context, s.category).then((resp) => {	
				console.log('resp');
				console.log(resp);
				_this.d_loading = null;
				_this.d_settingData = resp.settingData || {};
				_this.d_refData = resp.refData;
				_this.d_errMessage = resp.error || null;
			});

		},
	},
	watch: {}
};


function fn_getSettings() {

	const colsCommon_appref = [
		{key: 'disabled', thClass: 'th-chkBox'},
		{key: 'created', tdClass: 'td-crup'},
		{key: 'updated', tdClass: 'td-crup'},

	];


	return [
		{
			grpKey: 'app',
			grpLbl: 'Application Settings',
			settings: [
				{
					key: 'gen',
					label: 'General',
					context: 'appTenantSetting',
					category: 'general',
					type: 'frm',
				},
				{
					key: 'teamAnnc',
					label: 'Team Announcements',
					context: 'appTenantSetting',
					category: 'teamAnnouncements',
					type: 'frm',
				},
			],
		},
		{
			grpKey: 'usr',
			grpLbl: 'User Settings',
			settings: [
				{
					key: 'permission',
					context: 'appUserSetting',
					type: 'tbl',
					cols: [
						{key: 'userName'},
						{key: 'teamMemberName'},
						{key: 'permissions', title: 'Permissions Granted'},
					],
					propOpt: [
						'superUser',
						'editAppSettings',
						'viewTeamMembersDashboard',
						'viewTeamMembersCalendar',
						'setTeamMembersSalesGoals',
						'setReminderOptions'
					]
				},
			],
		},
		{
			grpKey: 'ddo',
			grpLbl: 'Dropdown Options',
			type: 'tbl',
			settings: [
				{key: 'accountType'},
				{key: 'taskType', label: 'Activity Type'},
                {key: 'category',plr:'ies'},
				{key: 'contractType'},
				{key: 'leadSource'},
				{key: 'marketSegment'},
				{key: 'opportunitySubStatus', plr: 'es'},
				{key: 'ownerType'},
                {key:  'role', plr:'s'},
			],
			cols: [
				{title: 'Id'},
				{title: 'Name', },
				{title: 'Description', },
				...colsCommon_appref
			]

		},
		{
			grpKey: 'cf',
			grpLbl: 'Custom Fields and Codes',
			settings: [
				{
					key: 'customField',
					context: 'customField',
					label:'Custom Field',
					type: 'tbl',
					cols: [
					    {title: 'Id'},
						{key:'label',title: 'Label'},
						{key: 'type',title:'Data type'},
						{key: 'context',title:'Used on'},
						{key:'listOfValues',title:'List of values'},
						...colsCommon_appref
					],
				},
			],
		},
		{
			grpKey: 'decs',
			grpLbl: 'Decisions',
			settings: [
				{
					key: 'bidFactorQuestion',
					context: 'decisionQuestion',
					type: 'tbl',
					cols: [
						{title: 'Id'},
						{key: 'question', title: 'Bid Factor Question'},
						{key: 'description'},
						{key: 'defaultWeight'},
						// {key: 'displayOrder', },
						...colsCommon_appref
					],
				},
				{
					key: 'decsOpt',
					label: 'Decision Options',
					context: 'appTenantSetting',
					category: 'decisionOptions',
					type: 'frm',
				},
			],
		},
		{
			grpKey: 'debr',
			grpLbl: 'Debriefs',
			settings: [
				{
					key: 'debriefQuestion',
					label: 'Debrief Questions',
					context: 'debriefQuestion',
					type: 'tbl',
					cols: [
						{title: 'Id'},
						{key: 'question', title: 'Debrief Question'},
						{key: 'description'},
						...colsCommon_appref
					],
				},
				{
					key: 'pDebriefQuestion',
					context: 'projectDebriefQuestion',
					label: 'Project Debrief Questions',
					type: 'tbl',
					cols: [
						{title: 'Id'},
						{key: 'question', title: 'Debrief Question'},
						{key: 'description'},
						...colsCommon_appref
					],
				},
			],
		},
		{
			grpKey: 'sg',
			grpLbl: 'Sales Goals',
			settings: [
				{
					key: 'salesGoalNoteCategory',
					context: 'salesGoalNoteCategory',
					plr: 'ies',
					type: 'tbl',
					cols: [
						{title: 'Id'},
						{key: 'noteCategory'},
						{key: 'description'},
						...colsCommon_appref
					],
				},
			],
		},
		{
			grpKey: 'cs',
			grpLbl: 'Construction Scopes',
			settings: [
				{
					key: 'constructionScope',
					context: 'constructionScope',
					plr: 's',
					type: 'tbl',
					cols: [
						{title: 'Id', Key:'Id'},
						{title:'Construction Division',key: 'constructionDivision'},
						{title:'Construction Scope',key:'constructionScope'},
						{title:'Description',key: 'description'},
						...colsCommon_appref
					],
				},
			],
		},
		{
			grpKey: 'vs',
			grpLbl: 'Vendor Statuses',
			settings: [
				{
					key: 'vendorStatus',
					context: 'vendorStatus',
					plr: 'es',
					type: 'tbl',
					cols: [
						{title: 'Id', Key:'Id'},
						{title:'Vendor Status',key: 'vendorStatus'},
						{title:'Description',key: 'description'},
						...colsCommon_appref
					],
				},
			],
		},
		{
			grpKey: 'intf',
			grpLbl: 'Interfaces',
			settings: [
				{
					key: 'inboundInterface',
					label: 'Inbound',
					context: 'inbound',
					type: 'tbl',
					cols: [
						{title: 'Id'},
						{key: 'interfaceName', title: 'Interface Name'},
						{key: 'description', title:"Description"},
						{key: 'outboundData', title:"Data to send"},
						...colsCommon_appref
					],
				},
				{
					key: 'outboundInterface',
					context: 'outbound',
					label: 'Outbound',
					type: 'tbl',
					cols: [
						{title: 'Id'},
						{key: 'interfaceName', title: 'Interface Name'},
						{key: 'description', title:"Description"},
						...colsCommon_appref
					],
				},
			],
		},		

	];

}

</script>



<style lang="less">
#settings {
	flex-wrap: nowrap;
	overflow-x: auto;
	> div.col {
		text-align: left;
		padding: 0;
		&:first-child {
			min-width: 150px;
			max-width: 200px;
		}
		&:nth-child(2) {
			min-width: 600px;
		}
	}
	.nav-tabs {
		border: none;
	}
	.nav-item {
		font-size: 0.8em;
		// background-color: white;
		a {
			padding: 0.2rem 0.2rem;
			margin: 0.3em 0;
			margin-left: 1em;
			border: none;
			border-left: solid 0.1em transparent;
		}
		a.active {
			font-weight: bold;
			border: none;
			border-radius: 0;
			border-left: solid 0.1em #4fa4ff;

			i.fa {
				color: #495057 !important;
			}
		}
		a:hover {
			border-radius: 0;
			border: none;
			border-left: solid 0.1em #4fa4ff;
			i.fa {
				color: #0056b3 !important;
			}
		}
	}
	.navbar-text {
		font-size: 0.9em;
		margin-left: 0.5rem;
		padding-bottom: 0;
		// border-bottom: solid 0.1em #495057;
	}
}
.btn-back{
		min-width: 60px;
		margin-left: 0.5em;
		border:none;
		}
</style>